var map = {
	"./cyber-security.webp": 92701,
	"./microsoft-365.webp": 1396,
	"./microsoft-azure.webp": 71035,
	"./power-automate.webp": 21737,
	"./power-bi.webp": 32154,
	"./students.webp": 98571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8272;